export const categories = [
    {
        id: 17,
        name: "Imóveis",
        img: "/images/imobiliario.jpg",
        srcs: [
            {
                id: 1,
                src: "/images/mktp-home/imobiliaria/imabiliaria-1.jpg",
            },
            {
                id: 2,
                src: "/images/mktp-home/imobiliaria/imabiliaria-2.jpg",
            },
            {
                id: 3,
                src: "/images/mktp-home/imobiliaria/imabiliaria-3.jpg",
            },
            {
                id: 4,
                src: "/images/mktp-home/imobiliaria/imabiliaria-4.jpg",
            },
            {
                id: 5,
                src: "/images/mktp-home/imobiliaria/imabiliaria-5.jpg",
            },
            {
                id: 6,
                src: "/images/mktp-home/imobiliaria/imabiliaria-6.jpg",
            },
        ],
    },
    {
        id: 35,
        name: "Formaturas",
        img: "/images/direto-book-formatura.jpg",
        srcs: [
            {
                id: 1,
                src: "/images/mktp-home/formatura/formatura-1.jpg",
            },
            {
                id: 2,
                src: "/images/mktp-home/formatura/formatura-2.jpg",
            },
            {
                id: 3,
                src: "/images/mktp-home/formatura/formatura-3.jpg",
            },
            {
                id: 4,
                src: "/images/mktp-home/formatura/formatura-4.jpg",
            },
            {
                id: 5,
                src: "/images/mktp-home/formatura/formatura-5.jpg",
            },
            {
                id: 6,
                src: "/images/mktp-home/formatura/formatura-6.jpg",
            },
        ],
    },
    {
        id: 19,
        name: "Alimentos",
        img: "/images/direto-book-alimentos.jpg",
        srcs: [
            {
                id: 1,
                src: "/images/mktp-home/alimento/alimento-1.jpg",
            },
            {
                id: 2,
                src: "/images/mktp-home/alimento/alimento-2.jpg",
            },
            {
                id: 3,
                src: "/images/mktp-home/alimento/alimento-3.jpg",
            },
            {
                id: 4,
                src: "/images/mktp-home/alimento/alimento-4.jpg",
            },
            {
                id: 5,
                src: "/images/mktp-home/alimento/alimento-5.jpg",
            },
            {
                id: 6,
                src: "/images/mktp-home/alimento/alimento-6.jpg",
            },
        ],
    },
    {
        id: 18,
        name: "E-commerce",
        img: "/images/direto-book-ecommerce.jpg",
        srcs: [
            {
                id: 1,
                src: "/images/mktp-home/ecommerce/ecormmerce-1.jpg",
            },
            {
                id: 2,
                src: "/images/mktp-home/ecommerce/ecormmerce-2.jpg",
            },
            {
                id: 3,
                src: "/images/mktp-home/ecommerce/ecormmerce-3.jpg",
            },
            {
                id: 4,
                src: "/images/mktp-home/ecommerce/ecormmerce-4.jpg",
            },
            {
                id: 5,
                src: "/images/mktp-home/ecommerce/ecormmerce-5.jpg",
            },
            {
                id: 6,
                src: "/images/mktp-home/ecommerce/ecormmerce-6.jpg",
            },
        ],
    },
    {
        id: 23,
        name: "Casamentos",
        img: "/images/direto-book-casamento.jpg",
        srcs: [
            {
                id: 1,
                src: "/images/mktp-home/casamento/casamento-1.jpg",
            },
            {
                id: 2,
                src: "/images/mktp-home/casamento/casamento-2.jpg",
            },
            {
                id: 3,
                src: "/images/mktp-home/casamento/casamento-3.jpg",
            },
            {
                id: 4,
                src: "/images/mktp-home/casamento/casamento-4.jpg",
            },
            {
                id: 5,
                src: "/images/mktp-home/casamento/casamento-5.jpg",
            },
            {
                id: 6,
                src: "/images/mktp-home/casamento/casamento-6.jpg",
            },
        ],
    },
    {
        id: 7,
        name: "Ensaios",
        img: "/images/direto-book-ensaios.jpg",
        srcs: [
            {
                id: 1,
                src: "/images/mktp-home/ensaio/ensaio-1.jpg",
            },
            {
                id: 2,
                src: "/images/mktp-home/ensaio/ensaio-2.jpg",
            },
            {
                id: 3,
                src: "/images/mktp-home/ensaio/ensaio-3.jpg",
            },
            {
                id: 4,
                src: "/images/mktp-home/ensaio/ensaio-4.jpg",
            },
            {
                id: 5,
                src: "/images/mktp-home/ensaio/ensaio-5.jpg",
            },
            {
                id: 6,
                src: "/images/mktp-home/ensaio/ensaio-6.jpg",
            },
        ],
    },
    {
        id: 20,
        name: "Corporativo",
        img: "/images/direto-book-corporativo.jpg",
        srcs: [
            {
                id: 1,
                src: "/images/mktp-home/corporate/corporate-1.jpg",
            },
            {
                id: 2,
                src: "/images/mktp-home/corporate/corporate-2.jpg",
            },
            {
                id: 3,
                src: "/images/mktp-home/corporate/corporate-3.jpg",
            },
            {
                id: 4,
                src: "/images/mktp-home/corporate/corporate-4.jpg",
            },
            {
                id: 5,
                src: "/images/mktp-home/corporate/corporate-5.jpg",
            },
            {
                id: 6,
                src: "/images/mktp-home/corporate/corporate-6.jpg",
            },
        ],
    },
    {
        id: 22,
        name: "Festas",
        img: "/images/direto-book-festa.jpg",
        srcs: [
            {
                id: 1,
                src: "/images/mktp-home/festa/festa-1.jpg",
            },
            {
                id: 2,
                src: "/images/mktp-home/festa/festa-2.jpg",
            },
            {
                id: 3,
                src: "/images/mktp-home/festa/festa-3.jpg",
            },
            {
                id: 4,
                src: "/images/mktp-home/festa/festa-4.jpg",
            },
            {
                id: 5,
                src: "/images/mktp-home/festa/festa-5.jpg",
            },
            {
                id: 6,
                src: "/images/mktp-home/festa/festa-6.jpg",
            },
        ],
    },
    {
        id: 28,
        name: "Pet",
        img: "/images/direto-book-pet.jpg",
        srcs: [
            {
                id: 1,
                src: "/images/mktp-home/pet/pet-1.jpg",
            },
            {
                id: 2,
                src: "/images/mktp-home/pet/pet-2.jpg",
            },
            {
                id: 3,
                src: "/images/mktp-home/pet/pet-3.jpg",
            },
            {
                id: 4,
                src: "/images/mktp-home/pet/pet-4.jpg",
            },
            {
                id: 5,
                src: "/images/mktp-home/pet/pet-5.jpg",
            },
            {
                id: 6,
                src: "/images/mktp-home/pet/pet-6.jpg",
            },
        ],
    },
    {
        id: '00',
        name: "Eventos Esportivos",
        img: "/icons/9_outros.svg",
        srcs: [
            {
                id: 1,
                src: "/images/mktp-home/esporte/esporte-1.jpg",
            },
            {
                id: 1,
                src: "/images/mktp-home/esporte/esporte-2.jpg",
            },
            {
                id: 1,
                src: "/images/mktp-home/esporte/esporte-1.jpg",
            },
            {
                id: 1,
                src: "/images/mktp-home/esporte/esporte-2.jpg",
            },
        ],
    },
    {
        id: 24,
        name: "Outros",
        img: "/icons/9_outros.svg",
        srcs: [
            {
                id: 1,
                src: "/images/mktp-home/outros/outros-1.jpg",
            },
            {
                id: 1,
                src: "/images/mktp-home/outros/outros-2.jpg",
            },
        ],
    },
];

export const subcategories = [
    { id: 7, name: "Diversos" },
    { id: 30, name: "Pré wedding" },
    { id: 31, name: "Trash the Dress" },
    { id: 32, name: "Gestante" },
    { id: 34, name: "Newborn" },
    { id: 33, name: "Infantil" },
    { id: 35, name: "Formaturas" },
    { id: 36, name: "Parto" },
];

export const timeOptions = [
    { label: "00:00", value: "00:00" },
    { label: "01:00", value: "01:00" },
    { label: "02:00", value: "02:00" },
    { label: "03:00", value: "03:00" },
    { label: "04:00", value: "04:00" },
    { label: "05:00", value: "05:00" },
    { label: "06:00", value: "06:00" },
    { label: "07:00", value: "07:00" },
    { label: "08:00", value: "08:00" },
    { label: "09:00", value: "09:00" },
    { label: "10:00", value: "10:00" },
    { label: "11:00", value: "11:00" },
    { label: "12:00", value: "12:00" },
    { label: "13:00", value: "13:00" },
    { label: "14:00", value: "14:00" },
    { label: "15:00", value: "15:00" },
    { label: "16:00", value: "16:00" },
    { label: "17:00", value: "17:00" },
    { label: "18:00", value: "18:00" },
    { label: "19:00", value: "19:00" },
    { label: "20:00", value: "20:00" },
    { label: "21:00", value: "21:00" },
    { label: "22:00", value: "22:00" },
    { label: "23:00", value: "23:00" },
];

export const durationOptions = [
    { label: "1 hora", value: "1" },
    { label: "2 horas", value: "2" },
    { label: "3 horas", value: "3" },
    { label: "4 horas", value: "4" },
    { label: "5 horas", value: "5" },
    { label: "6 horas", value: "6" },
    { label: "7 horas", value: "7" },
    { label: "8 horas", value: "8" },
    { label: "9 horas", value: "9" },
    { label: "10 horas", value: "10" },
    { label: "11 horas", value: "11" },
    { label: "12 horas", value: "12" },
    { label: "13 horas", value: "13" },
    { label: "14 horas", value: "14" },
    { label: "15 horas", value: "15" },
    { label: "16 horas", value: "16" },
    { label: "17 horas", value: "17" },
    { label: "18 horas", value: "18" },
    { label: "19 horas", value: "19" },
    { label: "20 horas", value: "20" },
    { label: "21 horas", value: "21" },
    { label: "22 horas", value: "22" },
    { label: "23 horas", value: "23" },
    { label: "24 horas", value: "24" },
];
